export default __webpack_public_path__ + "components/footer/dac-certification-two-tick@2x.png";